import { useContext, FC } from "react";
import { useParams } from "react-router-dom";
// Utils
import { AppContext } from "config/appProvider";
import { BU_TYPES } from "trading/constants";
import { getBUFromLocalStorage, getTokenFromLocalStorage } from "helpers/storage";
import { useGetBusinessUnits, useHasFeature } from "hooks";
// Routes
import { DashboardRoutes } from "./routes";
import DashboardWatcher from "pages/Dashboard/DashboardWatcher";
// Pages
import { ReportsMenu, SettingsMenu } from "pages";
import IntercomComponent from "pages/Intercom/IntercomComponent";
// Containers
import { DashboardHeader, DashboardMenu } from "containers/dashboard";
// Components
import { Root, Page } from "components";
import LoadingOverlay from "components/Common/LoadingOverlay";
import { FarmerReportsMenu } from "reports/components/FarmerReportsMenu";
import { Paywall } from "subscriptions/components/Paywall";
import { AsyncJobStatusMenu } from "animals/AsyncJobStatusMenu";

export const Dashboard: FC = () => {
  const { mainAppState } = useContext(AppContext);
  const { sectionName, buId } = useParams<DashboardPageParams>();

  const { data: businessUnits } = useGetBusinessUnits();
  const token = getTokenFromLocalStorage();
  const selectedBU = getBUFromLocalStorage();
  const isLoading = Boolean(selectedBU && businessUnits && businessUnits.length > 0);
  const isSettingsMode: boolean = sectionName === "settings";
  const isReportsMode: boolean = sectionName === "reports";
  const isFarmerReportsMode = sectionName === "reports-new";
  const isShowOfflineReportPage: boolean = useHasFeature("SHOW_OFFLINE_PAGE_FOR_REPORTS");
  let pageMenu: false | JSX.Element = false;
  pageMenu = isReportsMode
    ? !isShowOfflineReportPage && <ReportsMenu />
    : isSettingsMode && <SettingsMenu farmer={mainAppState.selectedBUType !== BU_TYPES.processor} />;
  if (isFarmerReportsMode) {
    pageMenu = <FarmerReportsMenu />;
  }

  return (
    <>
      {(isLoading && !(buId && +buId !== +mainAppState.selectedBU)) || !token ? (
        <Root menu={<DashboardMenu />}>
          <Page menu={pageMenu}>
            <Paywall />
            <DashboardHeader />
            <DashboardRoutes />
            <AsyncJobStatusMenu />
          </Page>
          <IntercomComponent />
        </Root>
      ) : (
        <LoadingOverlay />
      )}
      <DashboardWatcher />
    </>
  );
};
